export default "__VITE_ASSET__jiQH2ASs__"